import OrderProgress from "../../components/OrderProgress/OrderProgress";
import './CheckoutDelivery.scss';
import React, {useEffect, useState} from "react";
import CardAdresses from "../../components/CardAdresses/CardAdresses";
import Cookies from "js-cookie";
import {faArrowLeft, faLocationArrow} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useNavigate} from "react-router-dom";
import GoingBack from "../../components/GoingBack/GoingBack";
import OpenStreetMap from "../../utils/Maps/OpenStreetMap";
import isNumeric from "validator/es/lib/isNumeric";
import ButtonDeconnect from "../../components/Button Deconnect/ButtonDeconnect";
import AccountActiveOrNot from "../../components/AccountActiveOrNot/AccountActiveOrNot";
import {Loader} from "../../utils/Loader";
import TextAccountNotActiveWithDeconnectButton
    from "../../components/AccountActiveOrNot/TextAccountNotActiveWithDeconnectButton";

function CheckoutDelivery() {
    const [adresses, setAdresses] = useState([]);
    const [adresseId, setidAdresseDomicileChoisie] = useState("");
    const [inputErreurChoixLivraison, setInputErreurChoixLivraison] = useState("");
    const [inputErreurCodePostal, setInputErreurCodePostal] = useState("");
    const [codePostal, setCodePostal] = useState("");
    const [relais, setRelais] = useState(null);
    const [ville, setVille] = useState("");
    const navigate = useNavigate();
    const [selectedPoint, setSelectedPoint] = useState(Cookies.get('MondialRelayPoint'));
    const [latlng, setLatlng] = useState(null);
    const [accountActive, setAccountActive] = useState(null);
    const [loading, setLoading] = useState(false);
    const resetCookiesLivraison = () => {
        Cookies.remove('MondialRelayPoint');
        Cookies.remove('MondialRelayPointDetails');
        Cookies.remove('adresseId');
    }

    useEffect(() => {
        Cookies.set('MondialRelayPoint', selectedPoint, {expires: 0.1});
    }, [selectedPoint]);

    useEffect(() => {
        window.scrollTo(0, 0);
        resetCookiesLivraison();
        const cartItems = JSON.parse(localStorage.getItem("cart"));
        if (!cartItems || cartItems.length === 0) {
            navigate("/panier");
        }
        document.title = "Choix Livraison";
        try {
            window.scroll(0, 0);
            const getAllAdressesForAclient = async () => {
                const response = await fetch(`${process.env.REACT_APP_API_URL}adresses/`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${Cookies.get("auth_token")}`,
                        },
                    }
                );
                const adresses = await response.json();
                setAdresses(Object.values(adresses));
            }
            getAllAdressesForAclient();
        } catch (error) {
            console.log(error);
        }
    }, []);

    const validerChoixLivraison = () => {
        if (!selectedPoint && !adresseId) {
            setInputErreurChoixLivraison("Veuillez choisir une adresse à domicile ou un point relais.");
        } else if (!Cookies.get('MondialRelayPoint') && Cookies.get('adresseId')) {
            Cookies.remove('MondialRelayPoint');
            navigate("/checkout/payment");
        } else if (Cookies.get('MondialRelayPoint') && !Cookies.get('adresseId')) {
            Cookies.remove('adresseId');
            navigate("/checkout/payment");
        }
    }

    const fetchRelais = async () => {
        setRelais(null);
        if ((!isNumeric(codePostal) && codePostal.length > 2) || (isNumeric(codePostal) && codePostal.length === 5)) {
            setInputErreurCodePostal("");
        } else if (codePostal.length !== 5) {
            setInputErreurCodePostal("Veuillez renseigner un code postal ou une ville valide.");
            return;
        }
        Cookies.remove('adresseId');
        setLoading(true); // Assurez-vous de montrer que le chargement a commencé

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}mondialRelay/${codePostal}`, {
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                setInputErreurCodePostal("Aucun point relais trouvé pour ce code postal ou cette ville");
                setLoading(false);
                return;
            }

            const relais = await response.json();

            if (relais.length === 0) {
                setInputErreurCodePostal("Aucun point relais trouvé pour ce code postal ou cette ville");
            } else {
                setRelais(relais);
            }
        } catch (error) {
            console.error("Erreur lors de la récupération des points relais:", error);
            setInputErreurCodePostal("Une erreur est survenue lors de la récupération des points relais");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        Cookies.set('adresseId', adresseId, {expires: 0.1});
    }, [adresseId]);

    const goingBackToMainDelivery = () => {
        resetCookiesLivraison();
        setRelais(null);
    }

    const handleFetchRelais = (e) => {
        if (e.key === "Enter") {
            setLoading(true);
            fetchRelais();
        }
    };

    const handleGoBack = () => {
        resetCookiesLivraison();
        navigate("/panier");
    }

    return (
        <>
            <AccountActiveOrNot setAccountActive={setAccountActive}/>
            {accountActive === false && accountActive !== null ? (
                <TextAccountNotActiveWithDeconnectButton/>
            ) : (
                <div className="checkout-delivery-container">
                    <div style={{display: "flex", justifyContent: "center", marginBottom: "2rem"}}>
                        <a href="/">
                            <img src="https://res.cloudinary.com/dc1p20eb2/image/upload/v1711445140/Anne%27so%20Naturelle/logo/logo.png"
                                 alt="logo anneso-naturelle" height="125" width="200" />
                        </a>
                    </div>

                    <div className="return-to-collection" onClick={handleGoBack}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                        Retour au panier
                    </div>

                    <OrderProgress/>

                    {relais && (
                        <div className="return-to-collection" style={{marginTop: "1.5rem"}} onClick={() => goingBackToMainDelivery()}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                            Retour au choix de livraison
                        </div>
                    )}

                    <div className="div-main-checkout-delivery">
                        {/* Section Point Relais */}
                        <div className="delivery-card">
                            <div className="delivery-header">
                                <h3>Point Relais</h3>
                                <img src="https://res.cloudinary.com/dc1p20eb2/image/upload/v1710505083/Anne%27so%20Naturelle/Image/image_point_relais.png"
                                     alt="Livraison point relais" />
                                <h4>3.90 €</h4>
                                <hr />
                            </div>

                            <div className="delivery-relais-content">
                                <div className="input-code-postal-relais">
                                    <input type="text" value={codePostal}
                                           onChange={(e) => setCodePostal(e.target.value)}
                                           placeholder="Code Postal ou Ville"
                                           onKeyUp={(e) => handleFetchRelais(e)}
                                    />
                                    <FontAwesomeIcon icon={faLocationArrow}
                                                     id="icon-input-code-postal-relais"
                                                     onClick={() => {
                                                         fetchRelais();
                                                         setLoading(true);
                                                     }}/>
                                </div>
                                {inputErreurCodePostal !== "" && (
                                    <p style={{color: "#ef4444", textAlign: "center", marginBottom: "1rem", fontWeight: "500"}}>
                                        {inputErreurCodePostal}
                                    </p>
                                )}

                                {relais && (
                                    <div className="panel-relay-point">
                                        {relais.map((relai, index) => (
                                            <React.Fragment key={index}>
                                                {relai.PointRelais_Details.map((detail, idx) => {
                                                    const isSelected = Cookies.get('MondialRelayPoint') === detail.Num[0];
                                                    return (
                                                        <div key={idx} 
                                                             className={`relay-item ${isSelected ? 'selected' : ''}`}
                                                             onClick={() => {
                                                                 Cookies.set('MondialRelayPoint', detail.Num[0]);
                                                                 Cookies.set('MondialRelayPointDetails', JSON.stringify(detail));
                                                                 setSelectedPoint(detail.Num[0]);
                                                                 setLatlng([detail.Latitude[0], detail.Longitude[0]]);
                                                             }}>
                                                            <p>{detail.LgAdr1[0]}</p>
                                                            <p>{detail.LgAdr3[0]}</p>
                                                            <div className="relay-item-city">
                                                                <span>{detail.CP[0]}</span>
                                                                <span>{detail.Ville[0]}</span>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Carte Interactive si relais cherché */}
                        {relais && (
                            <div className="delivery-card" style={{padding: 0, overflow: 'hidden'}}>
                                <OpenStreetMap codePostal={codePostal} relayPoints={relais} selectedPoint={selectedPoint}
                                               latlng={latlng} setlng={setLatlng} setSelectedPoint={setSelectedPoint}
                                               loading={loading} />
                            </div>
                        )}

                        {/* Section Domicile */}
                        {!relais && (
                            <div className="delivery-card">
                                <div className="delivery-header">
                                    <h3>À Domicile</h3>
                                    <img src="https://res.cloudinary.com/dc1p20eb2/image/upload/v1710505531/Anne%27so%20Naturelle/Image/image_livraison_domicile.png"
                                         alt="Livraison à domicile" />
                                    <h4>5.90 €</h4>
                                    <hr />
                                </div>

                                <div className="delivery-domicile-content">
                                    <p style={{textAlign: "center", color: "#475569", marginBottom: "1rem"}}>
                                        {adresses.length > 0 ? "Sélectionnez votre adresse de livraison :" : "Vous n'avez pas encore renseigné d'adresse."}
                                    </p>

                                    {adresses && adresses.length > 0 && (
                                        <div className="domicile-addresses-list">
                                            {adresses.map((adresse) => (
                                                <div className="domicile-item" key={adresse._id}>
                                                    <input type="radio" value={adresse._id}
                                                           onChange={() => setidAdresseDomicileChoisie(adresse._id)}
                                                           checked={adresseId === adresse._id}
                                                    />
                                                    <CardAdresses
                                                        adresseId={adresse._id}
                                                        nomPersonne={adresse.nomPersonne}
                                                        prenomPersonne={adresse.prenomPersonne}
                                                        adresse={adresse.adresse}
                                                        codePostal={adresse.codePostal}
                                                        pays={adresse.pays}
                                                        ville={adresse.ville}
                                                        complementAdresse={adresse.complementAdresse}
                                                        numTel={adresse.numTel}
                                                        setAdresses={setAdresses}
                                                        adresses={adresses}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    <button id="bouton-ajout-adresse" onClick={() => navigate("/profil/adresses/ajoutAdresse")}>
                                        + Ajouter une nouvelle adresse
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="validation-section">
                        <button className="btn-validate-delivery" onClick={() => validerChoixLivraison()}>
                            Valider et passer au paiement
                        </button>
                        {inputErreurChoixLivraison !== "" && (
                            <div className="error-msg">{inputErreurChoixLivraison}</div>
                        )}
                    </div>
                </div>
            )}
        </>
    )
}

export default CheckoutDelivery;
